import { Button } from "@tql/ui-components-react/tql/buttons";
import { arrowCircleUpRightLine } from "@tql/ui-components-react/untitled/icons";
import type { ReactNode } from "react";
import { Link } from "react-router";

import type { ReportItem } from "../../types/report-types.ts";
import styles from "./reports-mobile.module.css";

type ReportFieldProps = {
	label: string;
	children: ReactNode;
};

const ReportField = ({ label, children }: ReportFieldProps) => (
	<div className={styles.reportField}>
		<span className={styles.reportFieldLabel}>{label}</span>
		{children}
	</div>
);

export type ReportsMobileProps = {
	reports: ReportItem[];
};

export const ReportsMobile = ({ reports }: ReportsMobileProps) => (
	<div className={styles.reportsMobileList}>
		{reports.map((report) => (
			<article
				key={report.id}
				className={styles.reportCard}
				data-testid={"report-card"}
			>
				<div className={styles.reportCardTopRow}>
					<ReportField label={"Report Name"}>
						<span className={styles.reportFieldValue}>{report.name}</span>
					</ReportField>
					<ReportField label={"Actions"}>
						<Link
							data-testid={"report-card-launch"}
							style={{ textDecoration: "none" }}
							to={`/reports/${report.id}`}
						>
							<Button svgIcon={arrowCircleUpRightLine} variant={"tertiary"}>
								Launch Report
							</Button>
						</Link>
					</ReportField>
				</div>
				<ReportField label={"Details"}>
					<span className={styles.reportFieldValue}>{report.details}</span>
				</ReportField>
			</article>
		))}
	</div>
);
